/* eye.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 21 16" preserveAspectRatio="none">
            <g>
                <path class="foreground-gl" d="M10.5,0C4.1,0,0.1,4.9,0,8c-0.1,3.1,4.1,8,10.5,8S21.1,10.5,21,8C20.9,5.7,16.9,0,10.5,0z M10.5,13.8
                    c-3.2,0-5.9-2.6-5.9-5.8c0-3.2,2.6-5.8,5.9-5.8c3.2,0,5.9,2.6,5.9,5.8C16.4,11.2,13.7,13.8,10.5,13.8z"/>
                <path class="foreground-gl" d="M10.5,5v3L8.4,5.9C7.8,6.4,7.5,7.2,7.5,8c0,1.7,1.4,3,3,3s3-1.3,3-3S12.2,5,10.5,5z"/>
            </g>
            </svg>
         `
};
